<template>
  <div class="outer-box" >
    <h4>Reset Agency SaaS Configurator</h4>

    <div class="inner-box" style="text-align: left; width: 600px;">
      <b-alert show variant="danger">
        <b>This step is irreversible.</b> Make sure that no location has a valid SaaS Plan.
      </b-alert>
      <input class="hl_input--wrap" type="text" placeholder="Company ID" v-model="companyId" />
      <p> ------ OR ------ </p>
      <input
        class="hl_input--wrap"
        type="text"
        placeholder="Company Email ID"
        v-model="companyEmail"
      />
      <button class="btn btn-danger mt-4" @click="disableSaas">
        <moon-loader v-if="processing" :loading="true" size="21px" color="#fafafa" />
        <span v-else>Reset</span>
      </button>
      <pre v-if="response" style="background-color: #f2f7fa;padding: 16px; margin-top: 16px">{{response}}</pre>
    </div>
  </div>
</template>

<script>
import { SaasService, SpmAppengineService } from "@/services";

export default {
  data() {
    return {
      companyId: '',
      companyEmail: '',
      processing: false,
      response: null
    };
  },
  methods: {
    async disableSaas(){
      this.processing = true
      if(!this.companyId) {
        try {
          let res = await SpmAppengineService.getCompanyIdFromCompanyEmail(this.companyEmail)
          this.response = res.data
          if(this.response?.company_id) {
            this.companyId = this.response.company_id;
          }
        } catch (err) {
          this.response = err.message;
          this.processing = false;
          return;
        }
      }
      SaasService.deleteSaasPlans(this.companyId)
        .then(response => {
          this.response = response.data
        })
        .catch(error => {
          this.response = error.message
        })
        .finally(() => {
            this.processing = false;
        });
    },
  }
}
</script>

<style>
</style>
